import { DollarSign, Gift, Home, MessageSquare, TrendingUp, User } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TabNavigationProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

const tabs = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'ask', label: 'AskREINZ', icon: MessageSquare },
  { id: 'tools', label: 'Estimate', icon: DollarSign },
  { id: 'insights', label: 'Insights', icon: TrendingUp },
  // { id: "compliance", label: "Compliance", icon: Shield },
  { id: 'benefits', label: 'Offers', icon: Gift },
  { id: 'practice', label: 'My Profile', icon: User },
]

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  return (
    <nav className="tab-bar z-50 shadow-lg">
      <div className="flex items-center justify-around px-2 py-2">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'flex flex-col items-center justify-center gap-1 px-2 py-1.5 rounded-lg transition-all duration-200 min-w-[56px]',
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <div className="relative">
                <div
                  className={cn(
                    'flex items-center justify-center w-10 h-7 rounded-full transition-all duration-200',
                    isActive && 'bg-secondary',
                  )}
                >
                  <Icon className={cn('w-5 h-5', isActive && 'text-primary')} />
                </div>
                {tab.id === 'ask' && (
                  <span className="absolute -top-2 -left-1 text-[8px] font-semibold text-white bg-primary leading-none whitespace-nowrap px-1 py-0.5 rounded-sm">
                    Beta
                  </span>
                )}
              </div>
              <span className={cn('text-3xs font-medium', isActive && 'text-primary')}>
                {tab.label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
